<template>
  <div>
    <div id="homeBox" class="homeBox">
      <!-- <img class="homeBox_img" src="../../../../static/img/headbg.jpg" alt=""> -->
			<div class="publicTop">
        <div class="home_logo">
          <img src="../../../../static/img/logo.png" alt="">
        </div>
				<div class="homeTop_right">
					<div class="homeTop_right_top">
            <span class="zhuxiao" v-show="!this.user" @click="clearUser()"><router-link :to="{name:'home'}">注销</router-link></span>
					</div>
					<div class="homeSearchInput">
            <el-input type="text" placeholder="请输入您想要的内容" v-model.trim="searchKey" @keyup.enter.native="searchss" id="el-input"></el-input>
            <div class="seatchInBtn" @click="searchss">
              <i class="iconfont icon-sousuo"></i>
              <em><a>搜索</a></em>
            </div>
          </div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import router from '@/router/index'
export default {
  data(){
    return{
      weixinShow:false,
      searchKey:'',
      userInfo:'',
      user:true
    }
  },
  methods:{
    onMouseOverC(){
      this.weixinShow = true
    },
    onMouseOutC(){
      this.weixinShow = false
    },
    toMenu(url){
      this.$router.push({
        path:url
      })
    },
    searchss() {
      this.$router.push({
        path:'/Search',
        query:{
          Title:this.searchKey
        }
      })
    },
    get(){
      var exp = 60 * 60 * 24 * 1000;
      var data = localStorage.getItem('userName');
      var dataObj = data;
      var dataTody = new Date().getTime()
      var dataObjB = JSON.parse(dataObj);
      if (dataTody - dataObjB > exp) {
        localStorage.clear();
      }else{
        var dataObjDatatoJson = dataObjB.data
        this.userName = dataObjDatatoJson;
        if(!this.userName){
          this.userInfo = '';
        } else {
          this.user = !this.user;
          this.userInfo = this.userName;
        }
        return dataObjDatatoJson;
      }
    },
    clearUser(){
      localStorage.removeItem('userName');
      this.$router.push({
        path:'/home'
      })
      location.reload();
      this.user = false;
      this.userName = ''
    }
  },
  watch:{
    searchVal:function(){
      this.focus();
    },
  },
  created(){
    this.get();
  }
}
</script>

<style lang="less" scoped>
#homeBox{
  width: 100%;
  height: 225px;
  // background:url('../../../../static/banImage/44.png') no-repeat;
  // background-size: cover;
  position: relative;
  .homeBox_img{
    width: 100%;
    height: 30px;
    position: absolute;
    top: 0;
  }
  .publicTop{
    width:1200px;
    height: 100%;
    margin:0 auto;
    position: relative;
    .home_logo{
      width: 575px;
      height: 100px;
      position: absolute;
      z-index: 9;
      // left: 41px;
      top: 65px;
      img{
        width: 575px;
        height: 110px;
      }
    }
    .homeTop_right{
      float: right;
    width: 380px;
    margin-top: 46px;
    height: 40px;
    position: relative;
    right: -9px;
      .homeTop_right_top{
        width: 63%;
        height: 15px;
        line-height: 15px;
        margin-left: 147px;
        i{
          font-size: 16px;
        }
        .spanss{
          margin-left: 67px!important;
        }
        span:nth-child(2){
          color:#000;
          font-size: 14px;
          margin-left: 7px;
        }
        span:nth-child(3),span:nth-child(5),span:nth-child(6){
          a{
            font-size: 14px;
            color: #000;
          }
          a:hover{
            color: #C01B22;
          }
          margin-top: 19px;
          margin-left:9px;
        }
        span:nth-child(4){
          margin-left: 8px;
        }
        .zhuxiao{
          a{
            font-size: 14px;
            color: #000;
          }
          a:hover{
            color: #C01B22;
          }
          margin-top: 19px;
          margin-left:9px;
        }
      }
      .homeSearchInput{
        width: 336px;
        height: 30px;
        border:1px solid #C01B22;
        margin-top:109px;
        position: absolute;
        right: 10px;
        input{
          width: 248px;
          height: 28px;
          border: none;
          outline: none;
          padding-left: 10px;
        }
        .seatchInBtn{
          width: 68px;
          height: 28px;
          position: absolute;
          top: 0;
          right: 0;
          border-left:1px solid #C01B22;
          background: #C01B22;
          cursor: pointer;
          i{
            font-size: 16px;
            color: #fff;
            position: absolute;
            top: 3px;
            left: 5px;
          }
          em{
            font-style: normal;
            position: absolute;
            right: 9px;
            top: 3px;
            a{
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
/deep/#el-input{
  width:100%!important;
  height: 28px!important;
  border:none!important;
  outline:none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/heade/index.vue